module.exports = __webpack_public_path__ + "static/media/family-suite-img5.a0276a03.jpg";